import { PDFDocument, StandardFonts } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { drawTextOnPage, truncateText } from "./StaticPdfUtils";

// PDF Path
const PDF = "/static/pdf/printList/discharge_planning.pdf";
const Font = "/static/fonts/THSarabunNew-Bold.ttf"; //* กรณีแก้ Font

const FormDischargePlanning = async (props: any) => {
  try {
    const existingPdfBytes = await fetch(PDF).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    // Loading Custom Font
    const fontUrl = Font;
    const fontBytes = await fetch(fontUrl).then((res) => res.arrayBuffer());
    pdfDoc.registerFontkit(fontkit);
    const customFont = await pdfDoc.embedFont(fontBytes);
    const zapFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

    const pages = pdfDoc.getPages();
    const fontSize = 12; //*

    // Page 1
    const pageOneCoordinates = [
      { text: props.items?.patientFullName, x: 367, y: 819 },
      { text: props.items?.hn, x: 515, y: 819 },
      { text: props.items?.birthdateAd, x: 384, y: 804 },
      { text: props.items?.age.toString(), x: 474, y: 804 },
      { text: props.items?.formatGender, x: 527, y: 804 },
      { text: props.items?.patientEncounter, x: 386, y: 789 },
      { text: props.items?.formatVisitDate, x: 492, y: 789 },
      { text: props.items?.doctorFullName || "-", x: 404, y: 774 },
      { text: props.items?.ipd_room, x: 524, y: 774 },
      { text: truncateText(props.items?.allergies, customFont, fontSize, 370, 567), x: 370, y: 758 }
    ];

    drawTextOnPage(pages[0], pageOneCoordinates, customFont, fontSize);

    const modifiedPdfBytes = await pdfDoc.save();
    const getAsBase64 = await pdfDoc.saveAsBase64();
    const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
    const modifiedPdfUrl = URL.createObjectURL(blob);

    return { uint8Array: modifiedPdfBytes, blobUrl: modifiedPdfUrl, blobRaw: blob, base64String: getAsBase64 }

  } catch (error) {
    console.error("Error modifying PDF: ", error);
    return {};
  }
};

export default FormDischargePlanning;